import {formatDistance} from "date-fns";
import {NavLink, useHistory} from "react-router-dom";
import {useCompanyId, useCurrentUser, usePlatformUrls} from "../../core";
import {AmProject} from "../../ps-types";
import {DeleteButton} from "../../ui/crud/DeleteButton.component";
import {buildEntityDef, EntityCrud} from "../../ui/crud/EntityCrud.component";
import {deleteAmProject, getAmProjects} from "./amProject.client";


function timeAgo(value: string) {
  return value ? formatDistance(new Date(value), new Date(), {addSuffix: true}) : "";
}

function ProjectLink({project: p}: {project: AmProject}) {
  const { amProjectNewVersion, amProjectDetails } = usePlatformUrls();

  return p.versions.length > 0 ?
    <NavLink to={() => amProjectDetails(p.id)}>{p.name}</NavLink>:
    <NavLink to={() => amProjectNewVersion(p.id)}>{p.name}</NavLink>
}

function DeleteBtn({entityName, entity, handleDelete}: {entityName: string, entity: any, handleDelete: (entity: any) => void}) {
  const content =`Are you sure you want to delete the ${entityName} '${entity["name"]}'?`;

  return <DeleteButton
    content={content}
    onDelete={() => handleDelete(entity)}
  />
}

export function DebtFundingProjects() {
  const history = useHistory();

  const companyId = useCompanyId();
  const user = useCurrentUser();

  const getEntities = (() => getAmProjects(companyId, "Debt-Funding"));
  // const createEntity =  async () => {
  //   const project = await createAmProject(companyId, "Debt-Funding");
  //   history.push(PS_URLS(companyId).amProjectNewVersion(project.id!))
  // }
  // const createMultipleEntity =  async () => {
  //   history.push(PS_URLS(companyId).amMultipleProjectNewVersion())
  // }


  const deleteEntity = (project: any) => deleteAmProject(companyId, project.id);

  let def = buildEntityDef(
    {
      entityName: "Debt",
      title: "My Debt Funding",
      getEntities,
      deleteEntity,
      table: {
        tableComponent: 'dataGrid',
        deleteButton: (props)=> (<DeleteBtn {...props} />)
      }
    },
    {
      name: {
        table: {
          render: (_value: string, project) =>
            <ProjectLink project={project as AmProject} />
        }
      },
      createdAt: {
        title: "CREATED",
        create: { type: "hidden" },
        table: { format: timeAgo }
      },
      "defaultVersionData.id": {
        title: "PROJECT ID",
        table: {
          format: (value: string, project) => {
            if(value){
              return value;
            } else {
              return project.id;
            }
          }
        },
        create: { type: "hidden" },
      },
      defaultVersion: {
        title: "DEFAULT VERSION",
        table: {
          format: (value: string, project) => project.versions.find((v: any) => v.versionId === value)?.title || ""
        },
        create: { type: "hidden" },
      },
      "Default Version Description": { // This is a dummy field name
        title: "DESCRIPTION",
        table: {
          format: (_value: string, project) => {
            const defaultVer = project.versions.find((v: any) => v.versionId === project.defaultVersion)
            let description = defaultVer?.description;
            return `${description || ""}`
          }
        },
        create: { type: "hidden" },
      },
      fileProcessedAt: {
        title: "EXCEL LAST PROCESSED",
        create: { type: "hidden" },
        table: { format: timeAgo }
      }
    }
  );

  return <div>
      <EntityCrud entityDef={def} />
  </div>
}
